module.exports = __webpack_public_path__ + "static/media/eye_view.5f0c5125.svg";